import React from 'react';
import { Alert, ListGroup } from 'react-bootstrap';
import { useDiagramStore } from '../store/diagramStore';

const TYPE_LABELS: Record<string, string> = {
  duplicate_id:   'Дубликат ID',
  cycle:          'Цикл',
  dangling_edge:  'Висячая связь',
  orphan_step:    'Изолированный шаг',
  invalid_lane:   'Невалидная зона',
};

const CollisionPanel: React.FC = () => {
  const collisions = useDiagramStore(s => s.collisions);

  if (collisions.length === 0) return null;

  return (
    <Alert variant="danger" className="m-2 p-2" style={{ fontSize: '0.78rem' }}>
      <Alert.Heading style={{ fontSize: '0.85rem' }}>
        Обнаружены коллизии ({collisions.length})
      </Alert.Heading>
      <ListGroup variant="flush" style={{ maxHeight: 200, overflowY: 'auto' }}>
        {collisions.map((err, i) => (
          <ListGroup.Item key={i} className="py-1 px-2" style={{ fontSize: '0.75rem' }}>
            <strong>{TYPE_LABELS[err.type] || err.type}:</strong> {err.message}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Alert>
  );
};

export default CollisionPanel;
